import { userApis } from '@apis/userApis';
import { useMutation } from '@hooks/useMutation';
import { AuthManager } from '@store/AuthManager';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const useJwtLogin = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: { email: string; password: string }) => {
      const response = await userApis.post('/jwt/login/', { body });
      if (response[400]) {
        if (response[400].non_field_errors?.includes('E-mail is not verified.')) {
          throw new FormError('NotVerifiedError', response[400]);
        }
        throw new FormError('LoginError', response[400]);
      } else if (response[401]) {
        throw new FormError('LoginError', response[401]);
      }
      return response[200]!;
    },
    {
      onSuccess: (data, { email }) => {
        AuthManager.shared.clear();
        AuthManager.shared.setUser({
          auth_type: 'Bearer',
          email,
          key: data.access,
          refresh: data.refresh,
          impersonatedUser: null,
          originalUser: null,
        });

        queryClient.invalidateQueries(['/user/']);
        queryClient.invalidateQueries(['/company/']);
      },
    },
  );
};
